import script from "./ManagementDoctorTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./ManagementDoctorTable.vue?vue&type=script&lang=ts&setup=true"

import "./ManagementDoctorTable.vue?vue&type=style&index=0&id=13234150&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13234150"]])

export default __exports__